import React from "react"

import { SqlConfig } from "@/metrics/registry/configuration"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"

const METRIC_TYPE_LABEL = "Custom SQL"

function renderSqlEditor(
  metricRecordData: MetricRecordData,
  onChange: (metric: MetricRecordData) => void,
): React.ReactNode {
  return <SqlConfig metricRecordData={metricRecordData} onChange={onChange} />
}

function renderSqlMetadataField(
  metricRecordData: MetricRecordData,
): React.ReactNode {
  const metricMetadata = metricRecordData.metric_metadata
  return (
    <div className="flex flex-col gap-2">
      <div>
        <h3 className="font-semibold">SQL Query: </h3>
        <p className="whitespace-pre-wrap font-mono text-sm">
          {metricMetadata?.sql_query}
        </p>
      </div>
      {metricMetadata?.aggregation_method ? (
        <div>
          <h3 className="font-semibold">Aggregation Method: </h3>
          <p>{metricMetadata.aggregation_method}</p>
        </div>
      ) : null}
      {metricMetadata?.unit ? (
        <div>
          <h3 className="font-semibold">Unit: </h3>
          <p>{metricMetadata.unit}</p>
        </div>
      ) : null}
    </div>
  )
}

/**
 * SQL Float metric: the query returns per-timestamp rows that are aggregated
 * into a single numeric value, reported in the configured unit.
 */
export class SqlFloatMetricRecord extends NumericalMetricRecord {
  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
    _textAreaRef?: React.RefObject<HTMLTextAreaElement>,
  ): React.ReactNode {
    return renderSqlEditor(metricRecordData, onChange)
  }

  renderMetricType(): React.ReactNode {
    return METRIC_TYPE_LABEL
  }

  renderMetadataField(metricRecordData: MetricRecordData): React.ReactNode {
    return renderSqlMetadataField(metricRecordData)
  }
}
